import React, { useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialSelect from "../../../components/MasterSelect";
import MaterialInput from "../../../components/MaterialInput";
import MaterialButton from "../../../components/MaterialButton";
import { Delete,Add } from "@mui/icons-material";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import {
  Card,
  CardContent,
  CardHeader,
  Button,
  Stack,
  Divider,
  Menu,
  MenuItem,
  Grid,
  Box,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import { useNavigate } from "react-router-dom";
import MaterialBox from "../../../components/MaterialBox";
function WorkflowApprover() {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
 const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const [rows, setRows] = useState([{ id: 1 }]); 

  const addRow = () => {
    setRows([...rows, { id: rows.length + 1 }]); 
  };

  const deleteRow = (id) => {
    setRows(rows.filter((row) => row.id !== id)); // Remove row by ID
  };

  const handlecancel = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to cancel?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onCancelAction(); // Call the function that handles cancel
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const onCancelAction = () => {
    navigate("/Workflow-manager");
  };


  return (
    <DashboardLayout>
       <ConfirmationDialog
                open={confirmationDialog.open}
                title={confirmationDialog.title}
                message={confirmationDialog.message}
                showCancel={confirmationDialog.showCancel}
                showConfirm={confirmationDialog.showConfirm}
                customSection={confirmationDialog.customSection}
                onConfirm={confirmationDialog.onConfirm}
                onCancel={confirmationDialog.onCancel}
              />
      <Card sx={{ padding: 2 }}>
        <CardHeader
          title="Workflows Approvers"
          action={
            <Stack direction="row" spacing={2}>
            {/* List Button */}
            <Button
              variant="contained"
              color="warning"
              sx={{
                px: 3,
                py: 1.2,
                borderRadius: "6px", // Subtle rounded corners
                fontWeight: "500",
                fontSize: "14px",
                textTransform: "none", // Keep text readable
              }}
            >
              List
            </Button>
          
            {/* Options Button */}
            <Button
              variant="contained"
              color="warning"
              onClick={handleMenuOpen}
              sx={{
                px: 3,
                py: 1.2,
                borderRadius: "6px",
                fontWeight: "500",
                fontSize: "14px",
                textTransform: "none",
                display: "flex",
                alignItems: "center",
                gap: "5px", // Space between text and arrow
              }}
            >
              Options ▼
            </Button>
          
            {/* Dropdown Menu */}
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleMenuClose}
              sx={{
                mt: 1, // Space from button
                borderRadius: "6px", // Subtle rounded corners
              }}
            >
              <MenuItem
                onClick={handleMenuClose}
                sx={{
                  fontWeight: "500",
                  fontSize: "14px",
                  px: 3, // Proper padding
                  py: 1.2,
                }}
              >
                Action
              </MenuItem>
              <MenuItem
                onClick={handleMenuClose}
                sx={{
                  fontWeight: "500",
                  fontSize: "14px",
                  px: 3,
                  py: 1.2,
                }}
              >
                Status
              </MenuItem>
            </Menu>
          </Stack>
          
          }
        />
        <CardContent  >
          <MaterialBox>
            <Grid container spacing={2}>
              
              <Grid item xs={12} sm={4}>
                <MaterialBox
                  mb={1}
                  ml={0.5}
                  lineHeight={0}
                  display="inline-block"
                >
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                    textTransform="capitalize"
                  >
                    Workflow Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput></MaterialInput>
              </Grid>
              <Grid item xs={12} sm={4}>
                <MaterialBox
                  mb={1}
                  ml={0.5}
                  lineHeight={0}
                  display="inline-block"
                >
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                    textTransform="capitalize"
                  >
                    Employee Category <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect />
              </Grid>
            </Grid>
          </MaterialBox>
          <Divider
            sx={{
              mt: 3,
              borderBottomWidth: 2,
              borderColor: "rgba(0, 0, 0, 0.6)",
            }}
          />

<MaterialBox>
  {rows.map((row) => (
    <Grid container key={row.id} spacing={2} sx={{ mb: 3 }}> {/* Added margin-bottom */}
      <Grid item xs={12} sm={1.3}>
        <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
          <MaterialTypography component="label" variant="caption" fontWeight="bold" textTransform="capitalize">
            Level #
          </MaterialTypography>
        </MaterialBox>
        <Box sx={{ marginLeft: "11px" }}>{row.id}</Box>
      </Grid>

      <Grid item xs={12} sm={3.1}>
        <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
          <MaterialTypography component="label" variant="caption" fontWeight="bold" textTransform="capitalize">
          Department 
          </MaterialTypography>
        </MaterialBox>
        <MaterialSelect fullWidth />
      </Grid>

      <Grid item xs={12} sm={3.1}>
        <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
          <MaterialTypography component="label" variant="caption" fontWeight="bold" textTransform="capitalize">
            Role
          </MaterialTypography>
        </MaterialBox>
        <MaterialSelect fullWidth />
       
      </Grid>

      <Grid item xs={12} sm={3.1}>
        <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
          <MaterialTypography component="label" variant="caption" fontWeight="bold" textTransform="capitalize">
            User
          </MaterialTypography>
        </MaterialBox>
        <MaterialSelect fullWidth />
      
      </Grid>

    
    </Grid>
  ))}

  {/* Add Button */}
  {/* <MaterialButton variant="contained" color="primary" startIcon={<Add />} onClick={addRow} sx={{ mt: -10 }}>
    Add
  </MaterialButton> */}
</MaterialBox>

  <MaterialBox
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
            >

               <>
                                <MaterialButton
                                  sx={{ m: 1 }}
                                  variant="gradient"
                                  color="dark"
                               
                                >
                                  Update
                                </MaterialButton>
                                <MaterialButton
                                  sx={{ m: 1, marginLeft: "4px" }}
                                  variant="gradient"
                                  color="dark"
                                  onClick={handlecancel}
                                >
                                  Cancel
                                </MaterialButton>
                              </>
            </MaterialBox>

        </CardContent>
      </Card>
    </DashboardLayout>
  );
}

export default WorkflowApprover;
